import { render, staticRenderFns } from "./Customer.vue?vue&type=template&id=08eb709e&scoped=true&"
import script from "./Customer.vue?vue&type=script&lang=ts&"
export * from "./Customer.vue?vue&type=script&lang=ts&"
import style0 from "./Customer.vue?vue&type=style&index=0&id=08eb709e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08eb709e",
  null
  
)

export default component.exports